import React from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
export function useScrollYPosition() {
    const [y, setY] = React.useState(0);
    useScrollPosition(({ currPos }) => {
        setY(currPos.y);
    }, []);
    return y;
}
//# sourceMappingURL=useScrollYPosition.js.map